/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Back_To_VisualInputs */

const cs_builder_back_to_visual = /** @type {(inputs: Builder_Back_To_VisualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět na vizuální`)
};

const en_builder_back_to_visual = /** @type {(inputs: Builder_Back_To_VisualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to visual`)
};

/**
* | output |
* | --- |
* | "Back to visual" |
*
* @param {Builder_Back_To_VisualInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_back_to_visual = /** @type {((inputs?: Builder_Back_To_VisualInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Back_To_VisualInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_back_to_visual(inputs)
	return cs_builder_back_to_visual(inputs)
});